var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 16,
    height: 16,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(1 -0.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129-2",
    "data-name": "Group 129",
    transform: "translate(-1 0.063)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M9.5,13.032a.774.774,0,0,0,.791-.753V10.773a.792.792,0,0,0-1.581,0v1.506a.774.774,0,0,0,.791.753m-3.163,0a.774.774,0,0,0,.791-.753V10.773a.792.792,0,0,0-1.581,0v1.506a.774.774,0,0,0,.791.753M13.451,4h-1.09L10.993,1.4a.788.788,0,0,0-.667-.462.8.8,0,0,0-.735.352.725.725,0,0,0-.006.785l1,1.921H5.245l1-1.921a.739.739,0,0,0-.374-.962A.815.815,0,0,0,4.84,1.4L3.472,4H2.382A2.337,2.337,0,0,0,.074,5.9,2.254,2.254,0,0,0,1.653,8.394l.587,5.618a2.333,2.333,0,0,0,2.372,2.032h6.625a2.33,2.33,0,0,0,2.372-2.032L14.2,8.394a2.256,2.256,0,0,0,1.579-2.5A2.343,2.343,0,0,0,13.451,4m-1.43,9.866a.778.778,0,0,1-.791.676H4.6a.778.778,0,0,1-.791-.676L3.253,8.514H12.58Zm1.43-6.854H2.382a.754.754,0,1,1,0-1.506h11.07a.754.754,0,1,1,0,1.506",
    transform: "translate(-0.009 -0.137)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order_icon.16e99145dfc7fb7a7ebd6c7dae954c68.svg";
export { ForwardRef as ReactComponent };